<div class="msgWrapper">
    <div class="msgError" [innerHTML]="errorMessage"></div>
</div>